import { useQuery } from '@tanstack/react-query';
import React from 'react';

import { NetworkTag } from '@/components';
import { cn } from '@/lib/utils';
import { getEnsName, WalletType } from '@/utils';

export const AddressInfo = ({
  address,
  network,
  formatAddress,
  className
}: {
  address: string;
  network: WalletType;
  formatAddress?: (v: string) => string;
  className?: string;
}) => {
  const { data: ens } = useQuery({
    queryKey: ['addressInfo', address],
    queryFn: () => {
      return getEnsName(address as `0x${string}`);
    },
    enabled: network === WalletType.EVM
  });
  return (
    <div className={cn('flex gap-[8px] items-center text-gray-600', className)}>
      <div className="font-medium">
        {formatAddress ? formatAddress(address) : address}
        {ens ? ` (${ens})` : ''}
      </div>
      <NetworkTag network={network} />
    </div>
  );
};
